import React from 'react';
import { useTranslation } from 'react-i18next';
import './InvalidSession.scss';

const InvalidSession = props => {
  const { t } = useTranslation();
  const { url } = props.location.state;
  return (
    <div className="session-expired alert alert--warning">
      <div className="alert__icon icon-warning-outline"></div>
      <div className="alert__message">
        <h4>{t('Security.accessDenied')}</h4>
        <div>{t('Security.accessDeniedMsg')}</div>
        {url && <a href={url}>Log In</a>}
      </div>
    </div>
  );
};

export default InvalidSession;
